export function ShowFeedbackWindow(questionIds: Array<number>, additionalData: Array<object>) {
    $.ajax({
        method: "POST",
        url: window.ETDR_RD.appConfig["UrlAction.HasUserVotedOrFeedbackExpired"],
        data: {
            'questionIds': questionIds
        },
        success: function (data) {
            if (!data.HasUserVoted) {
                FillOutFeedbackWindow(questionIds, additionalData);
            }
        }
    });
}

// visszajelző ablak bezárása
export function CloseFeedbackWindow(event: Event) {
    let feedbackWindow: JQuery = $(<HTMLElement>(<HTMLElement>event.target).closest(".feedback-window-wrapper"));

    let none = [];
    let questions = $('div[data-question-id]');

    questions.each((index: number, elem: HTMLElement) => {
        none.push({ 'questionId': $(elem).attr('data-question-id'), 'voteValue': 99, 'optionalFeedback': null });
    });

    if (feedbackWindow.length > 0) {
        SendFeedback(none);
        HideFeedbackWindow(feedbackWindow[0]);
    }
}

// visszajelző ablak elrejtése
export function HideFeedbackWindow(feedbackWindow: HTMLElement) {
    $('.feedback-window-wrapper > .top-right-corner').hide();
    $(feedbackWindow).hide();
}

var isVoteFunctionAttachedToClickEvent = false;

// szavazó gomb kattintás
export function Vote() {
    let feedbackWindow = $('#feedback-window');

    let feedbacks = [];

    $('.feedback-options').each(function () {
        let questionId = $(this).attr('data-question-id');
        let voteValue = $(this).children('div[chosen=\'true\']').attr('data-feedback-value');
        let optionalFeedback = $(this).parent().siblings('textarea[question-id=\'' + questionId + '\']').val();
        let additionalData = $(this).closest('.feedback-window').find('.additional-data').val();

            feedbacks.push({ questionId, voteValue, optionalFeedback, additionalData });
    });

    SendFeedback(feedbacks);
    Acknowledgments(feedbackWindow[0]);

    // köszönetnyilvánítás után várunk pár másodpercet, majd elrejtjük az ablakot
    setTimeout(function () {
        HideFeedbackWindow(feedbackWindow[0]);
    }, 4800);
}

// visszajelzés küldése
function SendFeedback(feedbacks: Array<object>) {
    $.ajax({
        type: "POST",
        url: window.ETDR_RD.appConfig["UrlAction.SaveFeedback"],
        data: {
            'feedbacks': feedbacks
        }
    });
}

// Köszönő felirat megjelenítése
function Acknowledgments(feedbackWindow: HTMLElement) {
    // Szövegek, gombok eltüntetése
    for (let i = 0; i < feedbackWindow.childElementCount; i++) {
        let childElement = feedbackWindow.children[i];
        $(childElement).fadeOut(450);
    }

    // Köszönő szöveg megjelenítése
    setTimeout(function () {
        feedbackWindow.innerHTML = '<p class="thanks-text" style="display:none;">Köszönjük visszajelzését!<p>';
        $(".thanks-text").fadeIn(600);
    }, 500);
}

function AppendFeedbackQuestionTemplateContent(element: JQuery, questionId: number, text: string, additionalData: string) {
    if ($('div[data-question-id=\'' + questionId + '\']').length === 0) {
        let content =
            `<div class="feedback-question">
                    <div class="feedback-text">`;

        text.includes('\\n') ? text.split('\\n').forEach((value) => { content = content + '<p>' + value + '</p>'; }) : content = content + '<p>' + text + '</p>';

        let voteTexts: Array<string> = ['borzasztó', 'gyenge', 'jó', 'szuper'];

        let cukikaVerySadUrl: string = window.ETDR_RD.appConfig["Constants.CukikaVerySadUrl"];
        let cukikaSadUrl: string = window.ETDR_RD.appConfig["Constants.CukikaSadUrl"];
        let cukikaHappyUrl: string = window.ETDR_RD.appConfig["Constants.CukikaHappyUrl"];
        let cukikaVeryHappyUrl: string = window.ETDR_RD.appConfig["Constants.CukikaVeryHappyUrl"];

        let voteImages: Array<string> = [
            `<img src="${cukikaVerySadUrl}" height="50" width="50">`,
            `<img src="${cukikaSadUrl}" height="50" width="50">`,
            `<img src="${cukikaHappyUrl}" height="50" width="50">`,
            `<img src="${cukikaVeryHappyUrl}" height="50" width="50">`,
        ]

        if (questionId == 11) {
            voteTexts = ['Jaj ne', 'Mindegy', 'Rendben'];
        }

        content = content + `</div>
                    <div class="feedback-options" data-question-id="` + questionId + `">`;

        for (var i = 0; i < voteTexts.length; i++) {
            content += `<div data-feedback-value="` + (i + 1) + `">
                                <div class="feedback-vote-image">` + voteImages[i] + `</div>
                                <div class="feedback-vote-text">` + voteTexts[i] + `</div>
                            </div>`
        }

        content += `</div>
                    </div>
                <div class="feedback-line mb-3">Írja meg nekünk véleményét!</div>
                <textarea placeholder="Maximum 250 karakter" class="mb-3" question-id="` + questionId + `"></textarea>`;
        additionalData ? content = content + '<input type="hidden" class="additional-data" value=\'' + additionalData + '\'>' : '';

        element.before(content);

        var button = $('.button-flexbox-wrapper > button');
        button.attr('disabled', 'disabled');
    }
}

export function FillOutFeedbackWindow(questionIds: Array<number>, additionalData: Array<object>) {
    $.ajax({
        type: "POST",
        url: window.ETDR_RD.appConfig["UrlAction.GetFeedbackQuestions"],
        data: { 'questionIds': questionIds },
        dataType: "json",
        success: function (data) {
            if (data) {
                if (!Array.isArray(questionIds)) {
                    AppendFeedbackQuestionTemplateContent($('#feedback-window > .button-flexbox-wrapper'), questionIds, data, additionalData ? JSON.stringify(additionalData) : null);
                }
                else {
                    $.each(data, function (k, v) {
                        AppendFeedbackQuestionTemplateContent($('#feedback-window > .button-flexbox-wrapper'), questionIds[k], v, additionalData ? JSON.stringify(additionalData[k]) : null);
                    });
                }

                var button = $('.button-flexbox-wrapper > button');

                var options = $('div[data-question-id] > div[data-feedback-value]');

                options.on('click', function () {
                    $(this).siblings().attr('chosen', 'false');
                    $(this).attr('chosen', 'true');

                    // Questions can be dynamically appended to the feedback DOM element.
                    // In some cases users may run into multiple feedbacks, so it's important to check the current state (number of questions attached to the feedback element).
                    let numberOfQuestions: number = $('[data-question-id]').length;

                    if ($('div[chosen=\'true\']').length === numberOfQuestions) {
                        button.removeAttr('disabled');

                        if (!isVoteFunctionAttachedToClickEvent) {
                            button.on('click', Vote);

                            isVoteFunctionAttachedToClickEvent = true;
                        }
                    }
                });

                $('.feedback-window-wrapper').show();
                $('.feedback-window-wrapper > .top-right-corner').show();
            }
        }
    });
}

export function FeedbackQuestionTriggerRefresh(s: MVCxClientGridView) {
    s.Refresh();
}

export function RefreshFeedbackSummaryGrid(s: MVCxClientGridView, e: ASPxClientGridViewRowClickEventArgs) {
    let summaryGrid: MVCxClientGridView = window['FeedbackSummary'];
    let focusedRowIndex: number = s.GetFocusedRowIndex();

    if (focusedRowIndex > -1) {
        summaryGrid.Refresh();
    }
}

export function AddSummaryPartialCallbackParameter(s: MVCxClientGridView, e: MVCxClientBeginCallbackEventArgs) {
    let questionGrid: MVCxClientGridView = window['FeedbackQuestions'];
    let questionId = questionGrid.GetRowKey(questionGrid.GetFocusedRowIndex());

    e.customArgs['questionId'] = questionId;
}
